import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthGuard} from '@spartacus/core';
import {AppComponent} from './app.component';
import {CmsPageGuard, PageLayoutComponent} from '@spartacus/storefront';
import {AuthGuardWithRedirection} from './checkout/guards/auth-guard-with-redirection.guard';
import {DynamicAuthGuard} from './checkout/guards/dynamic-auth.guard';
import {DynamicCheckoutStepSelectionGuard} from './checkout/guards/dynamic-checkout-step-selection.guard';
import {UserAccountFacadeUpdateGuard} from './checkout/guards/user-account-facade-update.guard';

// IMPORTANT: DcpRoutingModule MUST be imported before AppRoutingModule in app.module.ts.
// Spartacus AppRoutingModule registers a wildcard route that catches all unmatched paths
// for CMS-driven rendering. Our explicit routes below must be registered first so Angular
// matches them before the wildcard, preserving the correct route-level guards.
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'checkout',
        component: AppComponent,
        canActivate: [DynamicCheckoutStepSelectionGuard, UserAccountFacadeUpdateGuard],
      },
      {
        path: 'checkout/data-entry',
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard, AuthGuardWithRedirection],
        data: {cxRoute: 'checkoutDataEntry'},
      },
      {
        path: 'checkout/review-order',
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard, DynamicAuthGuard],
        data: {pageLabel: '/checkout/review-order'},
      },
      {
        path: 'order-confirmation',
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard, AuthGuardWithRedirection],
        data: {pageLabel: '/order-confirmation', redirectUrl: '/'},
      },
      {
        path: 'billing',
        canActivate: [AuthGuard],
        data: {pageLabel: '/billing'},
        loadChildren: () => import('./billing/billing.module').then((m) => m.BillingModule),
      },
    ]),
  ],
})
export class DcpRoutingModule {}
